var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPadlock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 8,
    viewBox: "0 0 7 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.07031 0.000976562C4.10567 0.000976562 4.94528 0.853584 4.94531 1.90527V2.66699H5.32031C5.73422 2.66699 6.07016 3.00831 6.07031 3.42871V7.23828C6.07026 7.65877 5.73428 8 5.32031 8H0.820312C0.406349 8 0.0703651 7.65877 0.0703125 7.23828V3.42871C0.0704679 3.00831 0.406413 2.66699 0.820312 2.66699H1.19531V1.90527C1.19534 0.853585 2.03495 0.0009787 3.07031 0.000976562ZM3.07031 0.762695C2.44911 0.762695 1.94554 1.27434 1.94531 1.90527V2.66797H4.19531V1.90527C4.19509 1.27434 3.69151 0.762696 3.07031 0.762695Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.a9c6a497c013c384fe30c0c18cf227b7.svg";
export { ForwardRef as ReactComponent };